import './App.css';

// import components
import Perfil from './components/Perfil';

function App() {
  return (
    <div className="App">
      <Perfil />
    </div>
  );
}

export default App;
